{
  "schemaVersion": "1.0",
  "status": "DRAFT_DIRECTIONAL",
  "note": "Directional marketing content. Prices are management targets; public-pricing.json must be generated from Pricing Master at publish.",
  "moduleId": "operate",
  "worksWith": [
    {
      "type": "REQUIRES",
      "target": "vault",
      "label": "Requires Vault"
    },
    {
      "type": "COORDINATES_WITH",
      "target": "shop",
      "label": "Work coordination & handoff"
    }
  ]
}